import { render } from "./ViewActionPoint.vue?vue&type=template&id=1df7f429&scoped=true"
import script from "./ViewActionPoint.vue?vue&type=script&lang=js"
export * from "./ViewActionPoint.vue?vue&type=script&lang=js"

import "./ViewActionPoint.vue?vue&type=style&index=0&id=1df7f429&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df7f429"]])

export default __exports__